import axios from '@/utils/request';

function CONTROL_SET(params) {
    return axios.get("/kshadmin/PanelRole/controlSet", {
        params: params
    })
}

function CONTROL_SET_POST(params) {
    return axios.post("/kshadmin/PanelRole/controlSetPost", {
        ...params
    })
}

export default {
    CONTROL_SET,
    CONTROL_SET_POST
};